import { Config as ConfigBase } from '@ortho-next/nextray-core';

export class Config extends ConfigBase {
  public static override readonly osteotomy_colorHex = 0xff0000;
  public static override readonly osteotomy_colorCss = "#ff0000";
  public static override readonly osteotomy_colorCssAlpha = "rgba(255, 0, 0, 0.6)";
  public static override readonly osteotomy_fontColor = "#ffffff";
}
